import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Divider, Row, Col, Statistic, Modal, Descriptions, Tabs, Popconfirm } from 'antd';
import CustomerService from "services/customer"
import DebtService from "services/debt"
import { formatCurrency } from "utils/number"
import { formatDate, formatOnlyDate } from "utils/date"
import { useNavigate } from 'react-router';
import UpdateDebt from 'components/debt/Update';
import AddDebt from "components/debt/AddDebt"
import AddPayment from "components/debt/AddPayment"
import _ from "lodash"
import { useApp } from 'contexts/app';
const service = new CustomerService();
const debtService = new DebtService();

const { Search } = Input;
const CustomerInfo = ({ phone, open, onClose }) => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [customer, setCustomer] = useState({});
    const [orders, setOrders] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filter, setFilter] = useState({ info: "" })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [lstDebt, setLstBebt] = useState([])
    const [lstDebtFilled, setLstDebtFilled] = useState([])
    const [updateDebt, setUpdateDebt] = useState({})
    const [debtFilter, setDebtFilter] = useState({ type: "has_remain_amount" })
    const app = useApp();
    useEffect(() => {
        if (isModalOpen != open)
            setIsModalOpen(open)
    }, [open])


    useEffect(() => {
        if (!isModalOpen && open && onClose) {
            onClose();
        }

    }, [isModalOpen])

    useEffect(() => {
        loadData({});
    }, [phone])

    //filter lst debt
    useEffect(() => {
        switch (debtFilter.type) {
            case "has_remain_amount":
                var lst = lstDebt.filter(x => x.type == "debt" && x.remain_amount > 0)
                setLstDebtFilled(lst)
                break;
            case "payment":
                var lst = lstDebt.filter(x => x.type == "payment")
                setLstDebtFilled(lst)
                break;
            case "all":

                setLstDebtFilled([...lstDebt])
                break;


            default:
                break;
        }

    }, [lstDebt, debtFilter])



    const loadData = async (data) => {
        setCustomer({});
        setOrders([])
        setLstBebt([])
        if (phone) {

            var cus = await service.getByPhone(phone);

            if (cus) {
                setCustomer(cus);
                setOrders(cus.orders);
                setLstBebt(cus.debts)
            }
        } else {
            setCustomer({});
            setOrders([])
            setLstBebt([])
        }

        // setData(lst);
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

    const onSearch = () => {
        delaySearch({});
    }

    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }
    const updateStats = async (id) => {
        await service.updateStats(id);
        loadData();
    }

    const showUpdateDebt = (debtId) => {
        setUpdateDebt({ isShow: true, id: debtId })
    }






    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };



    const renderTabOrder = () => {
        const columns = [
            {
                title: 'Mã đơn hàng',
                render: (record) => {
                    return (
                        <Space direction='vertical'>
                            <Button type='text' onClick={e => navigate(`/order/${record.id}`)}>
                                {record.id}
                            </Button>
                            <div>
                                {formatDate(record.create_on)}
                            </div>
                        </Space>
                    )

                }
            },


            {
                title: 'Sản phẩm',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            <div>
                                {record.total_item}
                            </div>
                            <div>
                                {formatCurrency(record.total_amount)}
                            </div>
                        </Space>
                    )


                    return record.total_item
                }
            },
            {
                title: 'Trạng thái',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            {record.status == "canceled" &&
                                <div>
                                    Đã Huỷ
                                </div>
                            }

                            {record.status == "finalized" &&
                                <div>
                                    Đã Hoàn tất
                                </div>
                            }

                            {!["canceled", "finalized"].includes(record.status) &&
                                <>
                                    <div>
                                        {record.payment_status.title}
                                    </div>
                                    <div>
                                        {record.shipping_status.title}
                                    </div>
                                </>
                            }


                        </Space>
                    )


                    return record.total_item
                }
            },


        ];
        return (
            <Table dataSource={orders} columns={columns} scroll={{ y: 300 }} />
        )
    }



    const renderTabDebt = () => {
        const columns = [
            {
                title: 'Ngày',

                render: (record) => {

                    return (
                        <Space direction='vertical'>

                            <div>
                                {formatOnlyDate(record.date)}
                            </div>
                        </Space>
                    )

                }
            },


            {
                title: 'Nội dung',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            <div>
                                {record.type == "payment" &&
                                    <>
                                        <b>Thanh toán: </b>
                                    </>
                                }
                                {record.description}
                            </div>

                        </Space>
                    )


                    return record.total_item
                }
            },
            {
                title: 'Số tiền',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            {formatCurrency(record.amount)}


                        </Space>
                    )

                }
            },
            {
                title: 'Đã thanh toán',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            {record.type == "debt" &&
                                <>
                                    {formatCurrency(record.paid_amount)}
                                </>
                            }

                        </Space>
                    )

                }
            },

              {
                title: 'Còn lại',

                render: (record) => {

                    return (
                        <Space direction='vertical'>
                            {record.type == "debt" &&
                                <>
                                    {formatCurrency(record.remain_amount)}
                                </>
                            }

                        </Space>
                    )

                }
            },

            {
                title: '',

                render: (record) => {

                    return (
                        <Space direction='horizontal'>
                            <Popconfirm onConfirm={e => deleteDebt(record.id)} title="Bạn chắc chắn muốn xoá?">
                                <Button type='link'>Xoá</Button>
                            </Popconfirm>

                            <Button type='link' onClick={e => showUpdateDebt(record.id)}>Cập nhật</Button>

                        </Space>
                    )

                }
            },



        ];
        return (
            <Space direction='vertical' style={{ width: "100%" }}>


                <Flex justify='flex-end' style={{ width: "100%" }}>
                    <Space>
                        <Space>
                            <label>Hiển thị</label>
                            <Select style={{ width: 150 }} value={debtFilter.type} onChange={e => setDebtFilter({ ...debtFilter, type: e })} options={[{ value: 'has_remain_amount', label: "Còn nợ" }, { value: 'payment', label: "Thanh toán" }, { value: 'all', label: "Tất cả" }]} />

                        </Space>
                        <AddPayment onSaved={loadData} customer_id={customer.id}></AddPayment>
                        <AddDebt onSaved={loadData} customer_id={customer.id}></AddDebt>
                    </Space>
                </Flex>
                <Table dataSource={lstDebtFilled} columns={columns} scroll={{ y: 300 }} />
            </Space>

        )
    }


    const deleteDebt = async debtID => {
        app.showLoading(true);
        await debtService.delete(debtID);
        app.showLoading(false);
        loadData();
    }

    const items = [
        {
            key: 'order',
            label: 'Đơn hàng',
            children: renderTabOrder(),
        },
        {
            key: '2',
            label: 'Công nợ',
            children: renderTabDebt(),
        },

    ];



    return (
        <>

            <Modal
                title="Thông  tin khách hàng"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={"50%"}
            >
                <Space style={{ width: "100%" }} direction='vertical'>


                    <Descriptions column={1} >
                        <Descriptions.Item label="Họ và tên">{customer.full_name}</Descriptions.Item>

                        <Descriptions.Item label="SDT">{customer.phone}</Descriptions.Item>

                        <Descriptions.Item label="Địa chỉ" span={3}>
                            {customer.address}
                        </Descriptions.Item>

                    </Descriptions>



                    <Row gutter={16}>
                        <Col flex="25%" >
                            <Statistic title="Đơn hàng" value={orders.length} />
                        </Col>
                        <Col flex="25%" >
                            <Statistic title="Số tiền" value={_.sumBy(orders, x => x.total_amount ?? 0)} precision={0} />
                        </Col>
                        <Col flex="25%" >
                            <Statistic title="Xu" value={customer.loyalty_point?.current ?? 0} precision={0} />

                        </Col>
                        {customer.debt?.current_debt != 0 &&
                            <Col flex="25%">
                                <Statistic title="Nợ" value={customer.debt?.current_debt ?? 0} precision={0} />
                            </Col>
                        }
                    </Row>
                    <Tabs items={items} />

                    <UpdateDebt onSaved={loadData} open={updateDebt.isShow} id={updateDebt.id} onClose={open => setUpdateDebt({ ...updateDebt, isShow: false })}></UpdateDebt>
                </Space>
            </Modal>
        </>

    )
}

export default CustomerInfo;
